import {
  isSharesProject,
  type Project,
} from "@tudigo-monorepo/core-tudigo-api-models";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";

import { getShareProjectTaxRateByPriorityOrder } from "../../../../pages/search-started-projects-page/utils/projects-comparator-simulator.utils";

const TRANSLATION_BASE_KEY = "component.project_card.header.badge.tax";

export type ProjectCardTaxBadgeVariant =
  | "default"
  | "new"
  | "accent-super-light"
  | "success-light";

export function useProjectCardTaxBadge(project?: Project): {
  label: string | null;
  variant: ProjectCardTaxBadgeVariant;
} {
  const label = useProjectCardTaxBadgeLabel(project);
  const variant = useProjectCardTaxBadgeVariant(project);

  return { label, variant };
}

function useProjectCardTaxBadgeLabel(project?: Project): string | null {
  const { t } = useTranslation();

  if (!project || !isSharesProject(project)) return null;

  const taxRate = getShareProjectTaxRateByPriorityOrder(project);

  if (taxRate > 1) {
    return t(`${TRANSLATION_BASE_KEY}.tax_rate`, { taxRate });
  }

  return null;
}

function useProjectCardTaxBadgeVariant(
  project?: Project,
): ProjectCardTaxBadgeVariant {
  return "success-light";
}
